import { ReadAllResponse, uuid } from "@/interfaces";
import { TaskWorkflowGrouped } from "@/models/task-workflow.model";
import { TaskWorkflowRepository } from "@/repositories/task-workflow.repository";

export async function fetchTaskWorkflow(service: uuid): Promise<ReadAllResponse<TaskWorkflowGrouped>> {
  return TaskWorkflowRepository.getAll(service);
}

export async function insertTaskWorkflowCategory({ service, title }: { service: uuid; title: string }): Promise<ReadAllResponse<TaskWorkflowGrouped>> {
  return TaskWorkflowRepository.createCategory(service, title);
}

export async function insertTaskWorkflow({ service, category, title }: { service: uuid; category: uuid; title: string }): Promise<ReadAllResponse<TaskWorkflowGrouped>> {
  return TaskWorkflowRepository.createTask(service, category, title);
}

export async function removeTaskWorkflowCategory({ service, category }: { service: uuid; category: uuid }): Promise<ReadAllResponse<TaskWorkflowGrouped>> {
  return TaskWorkflowRepository.deleteCategory(service, category);
}

export async function removeTaskWorkflow({ service, task }: { service: uuid; task: uuid }): Promise<ReadAllResponse<TaskWorkflowGrouped>> {
  return TaskWorkflowRepository.deleteTask(service, task);
}
